module.exports = __webpack_public_path__ + "img/Search_gray.1b288a9e.svg";